import { gql } from "@apollo/client";

export const setTosLatestAcceptedVersion = gql`
    mutation SetTosLatestAcceptedVersion($key: TosKey!) {
        setTosLatestAcceptedVersion(input: { key: $key }) {
            tos {
                key
                acceptedVersion
            }
        }
    }
`;
